export default 'M8 7v3h11v.02a8.75 8.75 0 1 1-14 0V7a7 7 0 0 1 13.93-1h-3.06A4 4 0 0 0 8 7';